import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CartRedirectComponent } from './cart-redirect/cart-redirect.component';
import { PackageViewComponent } from './package-view/package-view.component';
import { TileViewComponent } from './tile-view/tile-view.component';
import { AppViewComponent } from './app-view/app-view.component';

const routes: Routes = [
  { path: 'public/store/:partnerId', component: TileViewComponent },
  { path: 'public/store/:partnerId/package/:packageId', component: PackageViewComponent },
  { path: 'public/store/:partnerId/app/:appId', component: AppViewComponent },
  { path: 'public/store/:partnerId/app/:appId/addon/:addonId', component: AppViewComponent },
  { path: 'public/store/:partnerId/:marketId', component: TileViewComponent },
  { path: 'public/store/:partnerId/:marketId/package/:packageId', component: PackageViewComponent },
  { path: 'public/store/:partnerId/:marketId/app/:appId', component: AppViewComponent },
  { path: 'public/store/:partnerId/:marketId/app/:appId/addon/:addonId', component: AppViewComponent },
  { path: 'public/cart/:partnerId/:marketId/:packageId', component: CartRedirectComponent },

  // fallback paths that we should never use
  { path: ':partnerId/public/store', component: TileViewComponent },
  { path: ':partnerId/public/store/package/:packageId', component: PackageViewComponent },
  { path: ':partnerId/public/store/:marketId', component: TileViewComponent },
  { path: ':partnerId/public/store/:marketId/package/:packageId', component: PackageViewComponent },
  { path: '', redirectTo: '/public/store/ABC', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { paramsInheritanceStrategy: 'always' })],
  exports: [RouterModule],
})
export class StorefrontRoutingModule {}
